import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rate__left" }
const _hoisted_2 = { class: "rate__icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "rate__info" }
const _hoisted_5 = { class: "rate__name" }
const _hoisted_6 = { class: "rate__price" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Купить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    title: _ctx.hasSubscriptions ? 'Смена тарифа' : 'Тариф',
    subtitle: 
      _ctx.hasSubscriptions
        ? 'При смене тарифа, текущий перестанет работать. Если вы хотите его сохранить, рекомендуем приобрести тариф на новом акккаунте.'
        : 'После оплаты у вас активируется Wipon Pro на выбранном устройстве, и мы предоставим всю нужную информацию по использоваю.'
    
  }, {
    body: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratesData, (rate) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rate.type,
          class: "rate rate__list"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("img", {
                src: rate.icon,
                alt: ""
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(rate.name) + ", " + _toDisplayString(rate.duration) + " год", 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(Intl.NumberFormat("ru-RU", { style: "decimal" }).format(rate.price)) + " тг", 1)
            ])
          ]),
          _createVNode(_component_base_button, {
            type: "primary",
            filled: "",
            class: "rate__button",
            small: "",
            disabled: _ctx.account.balance < rate.price,
            onClick: ($event: any) => (_ctx.onClickBuy(rate))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}